import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(undefined);

const MANUAL_KEY = 'hacienda-lang-manual';
const SUPPORTED   = ['es', 'en', 'fr'];

function detectLang() {
  const saved = localStorage.getItem(MANUAL_KEY);
  if (saved && SUPPORTED.includes(saved)) return saved;

  const path = window.location.pathname;
  if (/^\/(us)(\/|$)/.test(path)) return 'en';
  if (/^\/(ca)(\/|$)/.test(path)) return 'fr';

  const b = navigator.language.toLowerCase();
  if (b.startsWith('es')) return 'es';
  if (b.startsWith('fr')) return 'fr';
  return 'en';
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState('en');

  useEffect(() => {
    setLangState(detectLang());
  }, []);

  useEffect(() => {
    const onPopState = () => {
      if (localStorage.getItem(MANUAL_KEY)) return;
      const path = window.location.pathname;
      if (/^\/(us)(\/|$)/.test(path)) { setLangState('en'); return; }
      if (/^\/(ca)(\/|$)/.test(path)) { setLangState('fr'); return; }
      const b = navigator.language.toLowerCase();
      setLangState(b.startsWith('es') ? 'es' : b.startsWith('fr') ? 'fr' : 'en');
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const setLang = (newLang) => {
    if (!SUPPORTED.includes(newLang)) return;
    setLangState(newLang);
    localStorage.setItem(MANUAL_KEY, newLang);
  };

  // t(en, es, fr?) — fr defaults to en when not provided
  const t = (en, es, fr) => {
    if (lang === 'es') return es;
    if (lang === 'fr') return fr ?? en;
    return en;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be inside LanguageProvider');
  return ctx;
}
